import {Country} from "../dto/country";

export default class StaticData{

  static FORM_DEBOUNCE_TIME = 1000;
  static DISABLED_BUTTON_TOOLTIP_TEXT = "Bitte geben Sie alle benötigten Daten an."
  static readonly FALLBACK_COUNTRIES: Country[] = ['Deutschland', 'Luxemburg', 'Niederlande', 'Österreich', 'Schweiz'].map(name => ({name}));
  static readonly DEFAULT_COUNTRY_NAME: string = 'Deutschland';

}
